import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function emptyRealizeLastArgumentErrCallback() {
  if (arguments && arguments.length > 0) {
    var _arguments;

    (_arguments = arguments[arguments.length - 1]) === null || _arguments === void 0 ? void 0 : _arguments.call(arguments, 'touch端浏览器暂不支持通过StatusBar进行导航栏配置');
  }
}

var _default = function _default() {
  _classCallCheck(this, _default);
};

_defineProperty(_default, "setHidden", emptyRealizeLastArgumentErrCallback);

_defineProperty(_default, "setStyle", emptyRealizeLastArgumentErrCallback);

_defineProperty(_default, "setColor", emptyRealizeLastArgumentErrCallback);

_defineProperty(_default, "setTranslucent", emptyRealizeLastArgumentErrCallback);

export { _default as default };